var map = {
	"./css3.svg": 69,
	"./django.svg": 70,
	"./expressjs.png": 71,
	"./flask.svg": 72,
	"./github.png": 73,
	"./github.webp": 74,
	"./html5.png": 75,
	"./intellij.png": 76,
	"./java.png": 77,
	"./javascript.png": 78,
	"./jenkins.png": 79,
	"./jira.png": 80,
	"./mongodb.svg": 81,
	"./mysql.png": 82,
	"./numpy.png": 83,
	"./numpy.svg": 84,
	"./openai.png": 85,
	"./openai.webp": 86,
	"./oracle.png": 87,
	"./pandas.png": 88,
	"./pandas.svg": 89,
	"./php.png": 90,
	"./postgresql.png": 91,
	"./pycharm.png": 92,
	"./python.webp": 93,
	"./pytorch.svg": 94,
	"./react.png": 95,
	"./redmine.png": 96,
	"./sass.png": 97,
	"./scikitlearn.png": 98,
	"./tensorflow.png": 99,
	"./tortoisesvn.png": 100,
	"./tortoisesvn.webp": 101,
	"./typescript.png": 102
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68;